<template>
  <Transition name="fade-fast">
    <main v-if="$page && $beet.isReady" class="content --home">
      <h2 class="title">{{ $page.subtitle }}</h2>
      <CourseCards :cards="cards" />
    </main>
  </Transition>
  <Transition name="fade-fast">
    <Loader v-if="!$page || !$beet.isReady" />
  </Transition>
</template>

<script>
import CourseCards from '@/components/cards/CourseCards.vue'
import Loader from '@/components/Loader.vue'
import PageMetaMixin from '@/mixins/PageMetaMixin.js'

export default {
  name: 'Home',
  beetPage: 'home',
  components: {
    CourseCards,
    Loader,
  },
  data() {
    return {
      open: true,
    }
  },
  computed: {
    cards() {
      return this.$beet.isReady
        ? Object.values(this.$beet.courses).filter((course) => course[this.$i18n.locale].length)
        : []
    },
  },
  watch: {
    $route() {
      this.$emit('updateTitle', this.$page.title)
    },
  },
  mixins: [PageMetaMixin],
}
</script>
